<template>
  <div class="content" style="width:800px">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="200px" >
      <el-form-item label="资费套餐:" prop="productId">
        <el-select v-model="propsParams.productId" filterable clearable placeholder="请选择资费套餐:" style="width:95%">
          <el-option v-for="item in optPackage" :key="item.id" :label="item.productName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="卡套餐激活时间:" prop="activationTime" >
        <el-select v-model="propsParams.activationTime" filterable clearable placeholder="请选择卡套餐激活时间:">
          <el-option v-for="item in productCycle" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否立即激活卡:" prop="cardActive" v-show="adminShow">
        <el-checkbox v-model="propsParams.cardActive">立即激活</el-checkbox>
      </el-form-item>
      <el-form-item label="ICCID/MSISDN列表:" prop="iccids">
        <el-input
          type="textarea"
          v-model="propsParams.iccids"
          rows="8"
          placeholder="以回车键分割ICCID/MSISDN"
        ></el-input>
      </el-form-item>
      <el-form-item label="ICCID/MSISDN范围:" prop="range">
        <el-row>
          <el-col :span="11">
            <el-input v-model="propsParams.startIccid" placeholder="包含开始值" clearable></el-input>
          </el-col>
          <el-col :span="2" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-input v-model="propsParams.endIccid" placeholder="包含终止值" clearable></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="密码:" prop="password">
        <el-input type="password" v-model="propsParams.password" placeholder="请输入密码" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit" >提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { batchOrder } from "@/api/api.js"; //批量充值
import { productList } from "@/api/api.js"; //不分页套餐列表
export default {
  name:"batchRecharge",
  data() {
    return {
      propsParams: {
        cardActive:false
      },
      submitLoading:false,
      optPackage: [],
      iccids: [],
      ruleValidate: {
        productId: [
          { required: true, message: "请输入资费名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      timeSet:[
        {
          value: 0,
          label: "立即激活"
        }, {
          value: 1,
          label: "1个月"
        }, {
          value: 2,
          label: "3个月"
        }, {
          value: 3,
          label: "6个月"
        }, {
          value: 4,
          label: "到期激活"
        }
      ],
      agentTimeSet:[
        {
          value: 0,
          label: "立即激活"
        }, {
          value: 1,
          label: "下月生效"
        }, {
          value: 4,
          label: "到期激活"
        }
      ]
    };
  },
  components: {},
  computed: {
    productCycle(){
      if(this.$store.getters.user.userType =='1'){
          return this.timeSet
        }
        return this.agentTimeSet;
      },
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
  },
  methods: {
    // 资费套餐下拉
    queryServerList() {
      productList().then(res => {
        if (res.data.code == 200) {
          this.optPackage = res.data.data;
           this.optPackage.map(item => {
             item.productName = item.id + "-" + item.productName
           })
        }
      });
    },
    handleSubmit() {
      let {cardActive} = this.propsParams;
      let params = {
        ...this.propsParams,
        cardActive:cardActive == true ? 1:0
      };
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          if (params.iccids !== undefined) {
            params.iccids = params.iccids.split(/[(\r\n)\r\n]+/);
          }
          batchOrder(params).then(res => {
            this.$message.success("批量充值成功");
            for(let i in this.propsParams) {
              this.propsParams[i] = "";
              this.propsParams["cardActive"] = false
            }
          });
        }
      });
    }
  },
  created() {
  },
  activated(){
    this.queryServerList();
  }
};
</script>
<style scoped lang="less">
  @media screen and (max-width: 750px){
    /deep/ .el-form-item__label{
      width: 75px!important;
    }
   /deep/ .el-form-item__content{
     margin-left: 120px!important;
   }
  }
</style>

